<template>
  <v-card
    flat
    style="width: 330px; height: 450px">
    <v-card-text class="text-center">
      <v-btn
        x-large
        disabled
        style="color: #2d2d2d !important; font-size: 20px !important"
        class="font-weight-bold ma-1"
        text>
        CanvasPro
      </v-btn>
    </v-card-text>
    <v-card-text>
      To reset your password enter your username and a reset token will be sent
      to your email.
    </v-card-text>
    <v-card-text>
      <v-text-field
        autofocus
        dense
        variant="outlined"
        v-model="username"
        bg-color="var(--v-fieldColor-base) !important"
        color="var(--text) !important"
        label="Username"></v-text-field>
      <v-btn
        :loading="reset_token_loading"
        variant="flat"
        block
        @click="send_reset_token()">
        Send Reset Token
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script setup>
import { ref } from 'vue';
import { $http } from '../../stores/http.js';
const reset_token_loading = ref(false);
const username = ref('');
async function send_reset_token() {
  if (!reset_token_loading.value) {
    reset_token_loading.value = true;
    try {
      await $http('PUT', '/generate_password_token?username=' + username.value);
      reset_token_loading.value = false;
    } catch (error) {
      console.log(error);
    }
  }
}
</script>
